// extracted by mini-css-extract-plugin
export default {"card":"card_card__kVWHz","headshot":"card_headshot__HsBZz","details":"card_details__DLLtk"};